import { ProductsConfig } from '../../../interfaces/mock.interface';

export const OPTIONS_MOCK: ProductsConfig[] = [
    {
        label: 'Pack sécurité Norton',
        gencode: '13071',
    },
    {
        label: 'B.tv - TV en direct illimitée',
        gencode: '12914',
    },
    {
        label: 'Disney+',
        gencode: '14371',
    },
];
export const ACCESSORIES_MOCK: ProductsConfig[] = [
    {
        label: 'Samsung Galaxy Watch',
        gencode: '8806097415657',
    },
     {
        label: 'watch 6',
        gencode: '8806095038827',
    },
    {
        label: 'Buds 2',
        gencode: '8806094512540',
    },
    {
        label: 'Xiaomi Pack connecté',
        gencode: '3662515018740',
    },
      {
        label: 'Rayban',
        gencode: '8056597988377',
    },
      {
        label: 'Pixel Watch 2',
        gencode: '0840353900660',
    },
];
